import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/info/banner',
  title: 'banner管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
